import {
  EnrollmentStep,
  ENROLLMENT_STEP_TITLES,
} from '../../state/enrollment/enrollmentModel';
import NavLink from './NavLink';
import styles from './Navigation.module.scss';
import classNames from 'classnames/bind';
import { setActiveStep } from '../../state/enrollment/enrollmentActions';

const cx = classNames.bind(styles);

export interface NavigationProps {
  enrollmentSteps: EnrollmentStep[];
  activeStepIndex: number;
  setActiveStep: typeof setActiveStep;
}

const Navigation = (props: NavigationProps) => {
  const { enrollmentSteps, activeStepIndex, setActiveStep } = props;

  const renderNavLinks = (step: EnrollmentStep, i: number) => {
    const isInactive: boolean = i < activeStepIndex;
    const isDisabled: boolean = activeStepIndex < i;
    const isLast: boolean = i === enrollmentSteps.length - 1;

    return (
      <NavLink
        key={step}
        step={i + 1}
        title={ENROLLMENT_STEP_TITLES[step]}
        inactive={isInactive}
        disabled={isDisabled}
        showArrow={!isLast}
        onClick={() => setActiveStep(step)}
      />
    );
  };

  return (
    <div className={cx('navigation')}>
      {enrollmentSteps.map((step: EnrollmentStep, i: number) =>
        renderNavLinks(step, i)
      )}
    </div>
  );
};

export default Navigation;
